// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/update_shotlist_config.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { VisionShotlistColumn, VisionShotlistConfig } from "./vision_shotlist_config_pb";
import { file_vision_shotlist_v1_vision_shotlist_config } from "./vision_shotlist_config_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/update_shotlist_config.proto.
 */
export const file_vision_shotlist_v1_update_shotlist_config: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vc2hvdGxpc3QvdjEvdXBkYXRlX3Nob3RsaXN0X2NvbmZpZy5wcm90bxIZcHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MSLNAgobVXBkYXRlU2hvdGxpc3RDb25maWdSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVXBkYXRlU2hvdGxpc3RDb25maWdSZXF1ZXN0LlBhcmFtcxIvCgt1cGRhdGVfbWFzaxgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2sarQEKBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEkgKD3Zpc2libGVfY29sdW1ucxgCIAMoDjIvLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVmlzaW9uU2hvdGxpc3RDb2x1bW4SRQoMY29sdW1uX29yZGVyGAMgAygOMi8ucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90bGlzdENvbHVtbiK5AQocVXBkYXRlU2hvdGxpc3RDb25maWdSZXNwb25zZRJOCgZyZXN1bHQYASABKAsyPi5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlVwZGF0ZVNob3RsaXN0Q29uZmlnUmVzcG9uc2UuUmVzdWx0GkkKBlJlc3VsdBI/CgZjb25maWcYASABKAsyLy5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvblNob3RsaXN0Q29uZmlnYgZwcm90bzM", [file_google_protobuf_field_mask, file_vision_shotlist_v1_vision_shotlist_config]);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateShotlistConfigRequest
 */
export type UpdateShotlistConfigRequest = Message<"protos.vision.shotlist.v1.UpdateShotlistConfigRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.UpdateShotlistConfigRequest.Params params = 1;
   */
  params?: UpdateShotlistConfigRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateShotlistConfigRequest.
 * Use `create(UpdateShotlistConfigRequestSchema)` to create a new message.
 */
export const UpdateShotlistConfigRequestSchema: GenMessage<UpdateShotlistConfigRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_shotlist_config, 0);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateShotlistConfigRequest.Params
 */
export type UpdateShotlistConfigRequest_Params = Message<"protos.vision.shotlist.v1.UpdateShotlistConfigRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShotlistColumn visible_columns = 2;
   */
  visibleColumns: VisionShotlistColumn[];

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShotlistColumn column_order = 3;
   */
  columnOrder: VisionShotlistColumn[];
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateShotlistConfigRequest.Params.
 * Use `create(UpdateShotlistConfigRequest_ParamsSchema)` to create a new message.
 */
export const UpdateShotlistConfigRequest_ParamsSchema: GenMessage<UpdateShotlistConfigRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_shotlist_config, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateShotlistConfigResponse
 */
export type UpdateShotlistConfigResponse = Message<"protos.vision.shotlist.v1.UpdateShotlistConfigResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.UpdateShotlistConfigResponse.Result result = 1;
   */
  result?: UpdateShotlistConfigResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateShotlistConfigResponse.
 * Use `create(UpdateShotlistConfigResponseSchema)` to create a new message.
 */
export const UpdateShotlistConfigResponseSchema: GenMessage<UpdateShotlistConfigResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_shotlist_config, 1);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateShotlistConfigResponse.Result
 */
export type UpdateShotlistConfigResponse_Result = Message<"protos.vision.shotlist.v1.UpdateShotlistConfigResponse.Result"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistConfig config = 1;
   */
  config?: VisionShotlistConfig | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateShotlistConfigResponse.Result.
 * Use `create(UpdateShotlistConfigResponse_ResultSchema)` to create a new message.
 */
export const UpdateShotlistConfigResponse_ResultSchema: GenMessage<UpdateShotlistConfigResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_shotlist_config, 1, 0);

